define(function(t,e){"use strict";function n(t){var e={};this.setCache=function(t,n){e[t]=n},this.getcacheFlag=function(){return!0},this.getCache=function(t){return e[t]},this.clearData=function(){e={}}}n.$inject=["lpWidget"],e.ReqAddonService=n});


// WEBPACK FOOTER //
// ./src/widget-nb-hdfc-addon-card/scripts/cache.js